export default __webpack_public_path__ + "static/media/flag_vietnam.b64ddd4f.svg";